module.exports = __webpack_public_path__ + "img/addiction-1.6238fb0.jpeg";